import React, {Fragment} from "react";
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  Divider,
  CardActions,
  Typography,
  Avatar,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Button,
  Tooltip,
  Grid,
  CircularProgress,
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import MyObjectivesIcon from "../../../../../assets/Images/exam_block_header_icon.png";
import AssignmentsIcon from '../../../../../assets/Images/exam_icon.png';
import ControlledSkelton from './ControlledSkelton';

const styles = theme => ({
  margin: {
    margin: theme.spacing(2)
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  },
  smallAvatar: {
    width: 30,
    height: 30
  },
  actions: {
    justifyContent: 'flex-end',
    textAlign: 'center'
  },
  btnText: {
    fontSize: 15,
    padding: 12,
    textTransform: 'capitalize'
  },
  bigAvatar: {
    width: 40,
    height: 40,
    marginTop: 5,
    borderRadius: 0
  }

});
const Exam = (props) => {
  
  const { classes, data, isLoading } = props;

  return (
    <Card className={classes.card}>
      <CardHeader
        title={<Typography color="primary">Exams</Typography>}
        subheader={"Upcoming exams"}
        avatar={<Avatar className={classes.bigAvatar} src={MyObjectivesIcon} />}
        style={{cursor:"pointer"}}
        onClick={() => window.location = "#/dashboard/F113Form/0"}
      />
      <CardContent style={{ height: '210px' }}>
      <List style={{
          marginTop: '-30px',
          height:238,
          overflow:"hidden",  
        }}>
          {data.length > 0 ?
            data.map((dt, i) => (
              <Fragment key={i}>
                <ListItem
                  style={{ paddingTop: 0 }}
                  alignItems="flex-start"
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Img"
                      src={AssignmentsIcon}
                      className={classes.smallAvatar}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    onClick={() => window.location = "#/dashboard/F113Form/0"}
                    style={{cursor:"pointer"}}
                    primary={
                      <Typography
                        component="legend"
                        className={classes.inline}
                        color="textPrimary"
                        style={{
                          flex:1, 
                          whiteSpace:"nowrap",
                          overflow:"hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                          {dt.label}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          variant="caption"
                          style={{ paddingLeft: "2px" }}
                        >
                          {<span>{"Start: "+dt.startDate}<br/>{"End: "+dt.endDate}</span>}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  {/* <Tooltip title="Download File">
                    <IconButton
                      onClick={(e) => props.downloadFile(e, dt.fileName)}
                      aria-label="download"
                      disabled={!dt.fileName}
                      color="primary"
                      style={{ marginTop: ".5em" }}
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip> */}
                </ListItem>
              </Fragment>
            ))
            :
            isLoading &&
            <Grid container justifyContent="center">
              {/* <CircularProgress /> */}
              <Grid size={12}>
                <ControlledSkelton />
              </Grid>
            </Grid>
          }
        </List>
      </CardContent>
      <Divider variant="middle" />
      <CardActions className={classes.actions}>
        <div>
          <Tooltip title="More">
            <Button 
              className={classes.btnText} 
              color="primary"
              onClick={() => window.location = "#/dashboard/F113Form/0"}
            >
              More
            </Button>
          </Tooltip>
        </div>
      </CardActions>
    </Card>
  );
}
Exam.propTypes = {
  classes: PropTypes.object.isRequired
}
export default withStyles(styles)(Exam);
